import { TextField, Select, MenuItem, Box, Typography, ButtonBase, Grid } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

const ATTIVITA = ['Dipendente', 'Lavoratore Autonomo', 'Pensionato', 'Casalinga', 'Studente', 'Disoccupato', 'Occupazione Saltuaria'];
const SETTORI = ['Industria', 'Commercio', 'Credito / Assicurazioni', 'Edilizia', 'Agricoltura', 'Stato', 'Trasporti', 'Servizi / Altro'];
const TIPO_ASSUNZIONE = ['Tempo Indeterminato', 'Tempo Determinato'];

const NEED_SECTOR = ['Dipendente', 'Lavoratore Autonomo', 'Occupazione Saltuaria'];

export default function Step8Occupazione({ data, onChange, errors }) {
  const showSector = NEED_SECTOR.includes(data.attivita_lavorativa);
  const showAssunzione = data.attivita_lavorativa === 'Dipendente';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          La tua attività
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Dicci cosa fai nella vita
        </Typography>
      </Box>

      <FieldWrapper label="Attività lavorativa" required error={errors?.attivita_lavorativa} completed={!!data.attivita_lavorativa}>
        <Grid container spacing={1}>
          {ATTIVITA.map(opt => (
            <Grid item xs={6} key={opt}>
              <ButtonBase
                onClick={() => onChange('attivita_lavorativa', opt)}
                sx={{
                  width: '100%',
                  py: 1.5,
                  px: 2,
                  borderRadius: 2,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  border: '2px solid',
                  textAlign: 'left',
                  justifyContent: 'flex-start',
                  transition: 'all 0.2s',
                  borderColor: data.attivita_lavorativa === opt ? 'primary.main' : 'divider',
                  bgcolor: data.attivita_lavorativa === opt ? 'primary.light' : 'transparent',
                  color: data.attivita_lavorativa === opt ? 'primary.main' : 'text.secondary',
                  '&:hover': { borderColor: 'primary.main' }
                }}
              >
                {opt}
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </FieldWrapper>

      {showSector && (
        <FieldWrapper label="Settore di attività" error={errors?.settore_attivita} completed={!!data.settore_attivita}>
          <Select 
            fullWidth 
            size="small" 
            value={data.settore_attivita || ''} 
            onChange={e => onChange('settore_attivita', e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>Seleziona settore</MenuItem>
            {SETTORI.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </Select>
        </FieldWrapper>
      )}

      {showSector && (
        <FieldWrapper label="Occupazione dal" error={errors?.occupazione_dal} completed={!!data.occupazione_dal}>
          <TextField fullWidth size="small" type="month" InputLabelProps={{ shrink: true }} value={data.occupazione_dal || ''} onChange={e => onChange('occupazione_dal', e.target.value)} />
        </FieldWrapper>
      )}

      {showAssunzione && (
        <FieldWrapper label="Tipo assunzione" error={errors?.tipo_assunzione} completed={!!data.tipo_assunzione}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {TIPO_ASSUNZIONE.map(opt => (
              <ButtonBase
                key={opt}
                onClick={() => onChange('tipo_assunzione', opt)}
                sx={{
                  flex: 1,
                  py: 1.5,
                  px: 2,
                  borderRadius: 2,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  border: '2px solid',
                  transition: 'all 0.2s',
                  borderColor: data.tipo_assunzione === opt ? 'primary.main' : 'divider',
                  bgcolor: data.tipo_assunzione === opt ? 'primary.light' : 'transparent',
                  color: data.tipo_assunzione === opt ? 'primary.main' : 'text.secondary',
                  '&:hover': { borderColor: 'primary.main' }
                }}
              >
                {opt}
              </ButtonBase>
            ))}
          </Box>
        </FieldWrapper>
      )}
    </Box>
  );
}